import { createApp } from 'vue'
import { Store } from '../model/store/Store'
import VueScrollTo from 'vue-scrollto'
import MachineTodayl1 from "../component/pages/machineIntroduction/MachineTodayl1.vue"

const unsavedPuriCount = document.getElementById('unsavedPuriCount').textContent
const latestImageId = document.getElementById('latestImageId').textContent.replace(/\s+/g, '')
const isSearchableStr = document.getElementById('isSearchable').textContent
const isSearchable = isSearchableStr.toLowerCase() === "true"

const vue = createApp(
    MachineTodayl1,
    {
        unsavedPuriCount: unsavedPuriCount,
        latestImageId: latestImageId,
        isSearchable: isSearchable,
    }
)
    .use(Store)
    .use(VueScrollTo)
    .mount('#todayl')

export default vue
